const errObj = (() => {
    return {
        success: 'false',
        errors: [
            {
                errCode: '100',
                message: 'Something went wrong',
                details: ''
            }
        ]
    };
})();
export default errObj;
